import { useMutation } from '@tanstack/react-query'

import { registerTfaAppVerificationCode } from '@src/api'
import { useAxios } from '@src/hooks'

export const useRegisterTfaAppVerificationCode = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: ({ verificationCode }: { verificationCode: string }) =>
      registerTfaAppVerificationCode(axiosInstance, { verificationCode }),
  })
}
